export default __webpack_public_path__ + "static/heroSectionBg-23ae6711c5c945660808659bd4539280.webp";